var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonalizedWalkthrough(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 14.8333,
    fill: "#F0EBFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2830_3986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.044 55H48.9551C51.881 55 54.2588 52.6222 54.2588 49.6963V23.2666C54.2588 20.3407 51.881 17.9629 48.9551 17.9629H46.8514V16.4815C46.8514 15.6666 46.1846 15 45.3698 15C44.555 15 43.8884 15.6666 43.8884 16.4815V17.9629H26.1107V16.4815C26.1107 15.6666 25.4439 15 24.6291 15C23.8143 15 23.1476 15.6666 23.1476 16.4815V17.9629H21.044C18.118 17.9629 15.7402 20.3407 15.7402 23.2666V49.6963C15.7402 52.6222 18.118 55 21.044 55ZM18.7033 23.2666C18.7033 21.9778 19.7551 20.9259 21.044 20.9259H23.1476V22.4074C23.1476 23.2222 23.8143 23.8888 24.6291 23.8888C25.4439 23.8888 26.1105 23.2222 26.1105 22.4074V20.9259H43.8884V22.4074C43.8884 23.2222 44.555 23.8888 45.3698 23.8888C46.1846 23.8888 46.8513 23.2222 46.8513 22.4074V20.9259H48.9549C50.2438 20.9259 51.2956 21.9778 51.2956 23.2666V27.5926H18.7033V23.2666ZM18.7033 30.5555H51.2959V49.6963C51.2959 50.9851 50.244 52.037 48.9552 52.037H21.044C19.7551 52.037 18.7033 50.9851 18.7033 49.6963V30.5555Z",
    fill: "#4B1598"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2830_3986"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(15 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalizedWalkthrough);
export default __webpack_public_path__ + "static/media/personalized-walkthrough.5540c40853ac8de00e003a85ffee1570.svg";
export { ForwardRef as ReactComponent };